import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {InfoActivityViewModel} from "../../services/models/activity/InfoActivityViewModel";
import {ActivitiesService} from "../../services/activities.service";
import {ActivitySaveResult} from "../../services/models/activity/ActivitySaveResult";

@Component({
  selector: 'app-info-activity',
  templateUrl: './info-activity.component.html',
  styleUrls: ['./info-activity.component.scss'],
})
export class InfoActivityComponent implements OnInit {
  @Input()activityUid!: string;
  current!: InfoActivityViewModel;
  constructor(
    private modalCtrl: ModalController,
    private activitiesService: ActivitiesService
  ) { }
  async ngOnInit() {
    this.current = await this.activitiesService.getInfoActivity(this.activityUid);
    console.log(this.current);
  }
  onClose_click() {
    const activitySaveResult = new ActivitySaveResult({
      activityValue: this.current.ActivityValue,
      bonusValue: this.current.BonusValue,
      gatheredBadge: this.current.GatheredBadge,
      gatheredUserLevel: this.current.GatheredUserLevel,
      isCorrect: true
    });
    return this.modalCtrl.dismiss(activitySaveResult, 'finished');
  }
}
